import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newBond() {
    let bondDetails = {
      fileopening_id: $(".fileopening_id").val(),
      cargo_id: $(".cargo_id").val(),
      bond_amount: $(".bond_amount").val(),
      t812_entry: $(".t812_entry").val()
    };
    $(".creatingBond").hide();
    $(".creatingBondLoader").show();
    baseurl.post(rt.newBond, bondDetails).then(res => {
      $(".creatingBond").show();
      $(".creatingBondLoader").hide();

      //checking response codes from backend api

      if (res.data.code === 200) {
        //success codes
        suc.bondCreateSuccess();
        router.push("/managecustombonds");
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 403) {
        //bond t812 entry exits
        ers.BondExists();
      } else if (res.data.code === 404) {
        //error on iserting data
        ers.errorCreatingBond();
      } else if (res.data.code === 405) {
        //no permission to create data
        ers.noPermissionToCreate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  loadBonds({ commit }) {
    baseurl.get(rt.loadBonds).then(res => {
      $(".bondsLoader").hide();

      //checking response codes from backend api

      if (res.data.code === 200) {
        //committing mutations
        commit("STORE_BONDS", res.data.bonds);
      } else if (res.data.code === 404) {
        //error on getting data
        ers.errorLoadingBond();
      } else if (res.data.code === 405) {
        //no permission to read
        ers.noPermissionToRead();
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },
  loadCustombonds({ commit }) {
    baseurl.get(rt.loadCustombonds).then(res => {
      $(".custombondsLoader").hide();

      //checking response codes

      if (res.data.code === 200) {
        //committing mutations
        commit("STORE_CUSTOMBONDS", res.data.custombonds);
      } else if (res.data.code === 404) {
        //error on loading data
        ers.errorLoadingCustomrelease();
      } else if (res.data.code === 405) {
        //no permission to read
        ers.noPermissionToRead();
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  viewBond({ commit }, bondId) {
    commit("STORE_BOND_UPDATE", bondId);
    router.push("/updatebond");
  },
  viewCustomBond({ commit }, cargoId) {
    commit("STORE_CUSTOMBOND_UPDATE", cargoId);
    router.push("/newbond");
  },
  viewBondtruck({ commit }, bondId) {
    commit("STORE_BOND_UPDATE", bondId);
    router.push("/newtruckrequisition");
  },

  bondUpdate({ commit }) {
    let bondDetails = {
      id: $(".id").val(),
      fileopening_id: $(".fileopening_id").val(),
      cargo_id: $(".cargo_id").val(),
      bond_amount: $(".bond_amount").val(),
      t812_entry: $(".t812_entry").val()
    };

    $(".updatingBond").hide();
    $(".updatingBondLoader").show();
    baseurl.post(rt.updateBond, bondDetails).then(res => {
      $(".updatingBond").show();
      $(".updatingBondLoader").hide();

      //checking response codes from backend api

      if (res.data.code === 200) {
        //success code
        suc.bondUpdateSuccess();
        commit("STORE_BONDS", res.data.bonds);
        setTimeout(() => {
          router.push("/managebonds");
        }, 3000);
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 404) {
        //error on updating data
        ers.errorUpdatingBond();
      } else if (res.data.code === 405) {
        //no permission to update
        ers.noPermissionToUpdate();
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/bonds/actions.js